import { nonNullable } from '@/shared/utils/typeAssertions'
import { inject, provide, type InjectionKey, type Ref } from 'vue'

export const hubContextToken = Symbol('hubContext') as InjectionKey<HubContext>

type HubContext = {
  workspaceId: Ref<string>
  hubId: Ref<string>
}

export const provideHubContext = (context: HubContext) => {
  provide(hubContextToken, context)
}

export const injectHubContext = () => {
  const context = inject(hubContextToken)
  return nonNullable(context)
}
